<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import WarehousesForm from './WarehousesForm.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = "/clients/system/company/warehouses/";
const title = "Warehouses";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const fields: TableField[] = [
  { name: "code", caption: "Code", sortable: true, fieldType: "text" },
  { name: "name", caption: "Name", sortable: true, fieldType: "text" },
  { name: "mobile", caption: "Mobile", sortable: true, fieldType: "text" },
  { name: "email", caption: "Email", sortable: true, fieldType: "text" },
  {
    name: "opening_hours",
    caption: "Opening Hours",
    sortable: true,
    fieldType: "text",
  },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]


const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

const permissions = ref<Permission[]>([])
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" @permissions="permissions = $event" :show-quick-tour="showQuickTour" :show-title="showTitle" :show-next-button="showNextButton">
  <template #form-view>
    <WarehousesForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>